// Post-processes the rich-text article body (`.article-body`) so the
// merchant can author it as plain HTML in the Shopify admin, while the
// front end renders the elaborate per-block Figma designs automatically:
//
// - Every <h2> gets a sequential id ("section-1", "section-2", ...) so the
//   "Content" jump-list - authored separately, in
//   article.metafields.custom.table_of_content, as a plain <ul> of
//   <a href="#section-N"> links in the same order as the h2s - has real
//   anchors to land on.
// - Every <ul>/<ol> inside the body gets a sequential class ("list-1",
//   "list-2", ...) - e.g. in-body checklists - each position gets its own
//   look in component-article-body.css.
// - Every <blockquote> gets a class cycling through "quote-1".."quote-6",
//   matching the six banner designs from Figma.
// - Every <table> is wrapped in a <div class="table"> so wide tables
//   scroll horizontally on narrow screens instead of breaking layout.
// - Any body image with alt text gets an orange caption bar appended right
//   below it, using that alt text - so a caption is just "set the image's
//   alt text" in the editor's image settings, nothing extra to type.
document.addEventListener('DOMContentLoaded', function () {
  var content = document.querySelector('.article-body');
  if (!content) return;

  content.querySelectorAll('h2').forEach(function (heading, index) {
    if (!heading.id) heading.id = 'section-' + (index + 1);
  });

  // content.querySelectorAll('img[alt]').forEach(function (img) {
  //   if (img.closest('.article-gallery')) return;
  //   var altText = (img.getAttribute('alt') || '').trim();
  //   if (!altText) return;
  //   var host = img.closest('p') || img;
  //   var caption = document.createElement('div');
  //   caption.className = 'image-caption';
  //   caption.textContent = altText;
  //   host.insertAdjacentElement('afterend', caption);
  // });

  // Skip the gallery's own slider <ul> - if the merchant typed "[gallery]"
  // in the middle of a paragraph instead of as its own line, the browser's
  // HTML parser can end up moving that <ul> out from under
  // <slideshow-component class="article-gallery"> entirely (an unclosed
  // <p> around the shortcode forces an early close), so a plain
  // .closest('.article-gallery') check isn't enough - check the slider's
  // own class too.
  var listIndex = 0;
  content.querySelectorAll('ul, ol').forEach(function (list) {
    if (list.closest('.article-gallery') || list.classList.contains('article-gallery__slider')) return;
    listIndex += 1;
    list.classList.add('list-' + listIndex);
  });

  // The Content jump-list (article.metafields.custom.table_of_content)
  // lives outside `.article-body`, so it's wired up separately here,
  // scrolling with the same header-aware offset used elsewhere in the
  // theme (see scrollToWithHeaderOffset in global.js).
  document.querySelectorAll('.article-toc a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.getElementById(this.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      if (typeof scrollToWithHeaderOffset === 'function') {
        scrollToWithHeaderOffset(target);
      } else {
        target.scrollIntoView({ block: 'start' });
      }
      history.replaceState(null, '', this.getAttribute('href'));
    });
  });

  var quoteAuthor = null;
  var authorDataEl = document.getElementById('ArticleAuthorData');
  if (authorDataEl) {
    try {
      quoteAuthor = JSON.parse(authorDataEl.textContent);
    } catch (e) {
      quoteAuthor = null;
    }
  }

  content.querySelectorAll('blockquote').forEach(function (quote, index) {
    var position = (index % 6) + 1;
    quote.classList.add('quote-' + position);

    if (position === 6 && quoteAuthor && (quoteAuthor.name || quoteAuthor.image)) {
      var row = document.createElement('div');
      row.className = 'quote-6__author';
      if (quoteAuthor.image) {
        var avatar = document.createElement('span');
        avatar.className = 'quote-6__avatar';
        avatar.innerHTML = '<img src="' + quoteAuthor.image + '" width="40" height="40" alt="" loading="lazy">';
        row.appendChild(avatar);
      }
      if (quoteAuthor.name) {
        var name = document.createElement('span');
        name.className = 'quote-6__name';
        name.textContent = quoteAuthor.name;
        row.appendChild(name);
      }
      quote.appendChild(row);
    }
  });

  content.querySelectorAll('table').forEach(function (table) {
    var wrapper = document.createElement('div');
    wrapper.className = 'table';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });

  // Splitting article.content around "[gallery]" (see main-article.liquid)
  // - and, the same way, around every "[prod_N]" product card - can leave an
  // empty, whitespace-only <p></p> behind (each one closes the paragraph
  // before the inserted content and reopens a fresh one after, so it never
  // sits nested inside a <p>). Drop those before the product-grouping step
  // below, so two cards separated only by one of these leftover empty <p>s
  // are still seen as adjacent siblings.
  content.querySelectorAll('p').forEach(function (p) {
    if (!p.textContent.trim() && !p.querySelector('img, br')) {
      p.remove();
    }
  });

  // Products: now that the paragraph-splitting above guarantees each
  // "[prod_N]" card (a <product-component> wrapping the actual
  // .card-wrapper markup) never sits inside a <p>, adjacent cards are true
  // DOM siblings - group runs of them into a single product-grid row
  // instead of stacking each as its own row.
  content.querySelectorAll('product-component').forEach(function (card) {
    var li = document.createElement('li');
    li.className = 'grid__item';
    var prev = card.previousElementSibling;
    if (prev && prev.classList.contains('article-product-grid')) {
      li.appendChild(card);
      prev.appendChild(li);
    } else {
      var grid = document.createElement('ul');
      grid.className = 'grid product-grid article-product-grid grid--2-col-desktop grid--2-col-tablet-down';
      grid.setAttribute('role', 'list');
      card.parentNode.insertBefore(grid, card);
      li.appendChild(card);
      grid.appendChild(li);
    }
  });
});
